<!-- 文档1：https://nuxtseo.com/docs/seo-utils/api/breadcrumbs -->
<template>
  <!-- 背景容器 -->
  <div :class="['w-full bg_linear_to_l shadow-2xl']">
    <!-- 实际内容容器 -->
    <div
      :class="[
        'page_view',
        'h-(--ui-crumb-height)',
        'flex justify-start items-center',
        'overflow-auto',
      ]"
    >
      <UTheme
        :ui="{
          breadcrumb: {
            link: ['text-white hover:text-primary'],
            separatorIcon: ['text-white'],
          },
        }"
      >
        <!-- items运算说明：如果传了自定义面包屑就用自定义的，否则用自动生成的 -->
        <UBreadcrumb
          separator-icon="fe:arrow-right"
          :items="props.customCrumbs?.length ? props.customCrumbs : autoSeoBreadcrumbs"
        >
          <!-- 对于自动面包屑特殊处理 -->
          <template v-if="!props.customCrumbs?.length" #item-label="{ item }">
            {{ t(`page.${formatPathDot(String(item.to)).value}.title`) }}
          </template>
        </UBreadcrumb>
      </UTheme>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import type { BreadcrumbItem } from '@nuxt/ui'

  interface CrumbList {
    customCrumbs?: BreadcrumbItem[]
  }

  const props = withDefaults(defineProps<CrumbList>(), {})

  const { t } = useI18n()
  const { formatPathDot } = useI18nTools()

  /** 由seo工具，结合当前路由，自动生成的面包屑 */
  const autoSeoBreadcrumbs: Ref<BreadcrumbItem[]> = useBreadcrumbItems()
</script>
